import React from 'react'

import { DashboardItemProps } from '../types'
import { IframeContainer } from './Iframe.styled'

export default function Iframe({
    data,
    componentStyle,
}: Readonly<DashboardItemProps>) {
    return (
        <IframeContainer componentStyle={componentStyle}>
            <iframe title={data.url} src={data.url} data-testid="iframe" />
        </IframeContainer>
    )
}
